import React from 'react';  
import Layout from '../../components/UI/Layout/Layout'

function Settings() {
  return <Layout>
      Settings
       
  </Layout> ;
}

export default Settings;
